import styled from "@emotion/styled";
import type { ReactNode } from "react";

import { MDSFadeHorizontalScroll } from "@/mds";

export const AgentHorizontalCardCarousel = ({
  ariaLabel,
  children,
}: {
  ariaLabel: string;
  children: ReactNode;
}) => <StyledCarousel aria-label={ariaLabel}>{children}</StyledCarousel>;

const StyledCarousel = styled(MDSFadeHorizontalScroll)`
  gap: ${({ theme }) => theme.spacing[3]};
  max-width: 100%;
  padding: ${({ theme }) => theme.spacing[1]};
  scroll-padding-inline: ${({ theme }) => theme.spacing[1]};
  scroll-snap-type: x proximity;

  > * {
    flex: 0 0 280px;
    scroll-snap-align: start;
  }

  @media (max-width: 620px) {
    > * {
      flex-basis: min(82vw, 280px);
    }
  }
`;
